<template>
  <small v-if="groupItem.error" class="error-label">{{groupItem.error}}</small>
  <span v-else class="numbers">
    {{groupItem.sms}} texts, {{groupItem.email}} emails
  </span>
</template>

<script>
  export default {
    props: {
      groupItem: Object,
    }
  }
</script>